import { render, staticRenderFns } from "./BaseUploadDragger.vue?vue&type=template&id=1fdda94a&"
import script from "./BaseUploadDragger.vue?vue&type=script&lang=js&"
export * from "./BaseUploadDragger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdda94a')) {
      api.createRecord('1fdda94a', component.options)
    } else {
      api.reload('1fdda94a', component.options)
    }
    module.hot.accept("./BaseUploadDragger.vue?vue&type=template&id=1fdda94a&", function () {
      api.rerender('1fdda94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseUploadDragger.vue"
export default component.exports